import { EMP_EXIT_MANAGEMENTS } from '../utils/constants.json';

const INITIAL_STATE = {
  empId: '',
};
/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case EMP_EXIT_MANAGEMENTS.NON_FSE_LOGIN_NOTIFICATION:
      return { ...state, ...payload };

    default:
      return { ...state };
  }
}
